import { useEffect, useState } from "react";
import { SmartFormInterFace, SmartSoftButton, SmartSoftForm, SmartValid } from "soft_digi";

import { useSiteContext } from "../../contexts/SiteProvider";
import { showNotification } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";

const initialValue = {
  ename: "",
  euserid: "",
  roles: "",
  emailid: "",
}
interface childrenProps {
  dataIn?: any,
  loadData: () => void
}

const UsersForm: React.FC<childrenProps> = ({ dataIn, loadData }) => {
  const [formData, setFormData] = useState(initialValue);
  const [roles, setRoles] = useState([])
  const { setLoading, closeModal } = useSiteContext();

  useEffect(() => {
    if (dataIn) {
      //console.log("roles",dataIn?.role);
      let updatedForm = {
        ename: dataIn?.ename,
        euserid: dataIn?.euserid,
        roles: dataIn?.roles,
        emailid: dataIn?.emailid,
      }
      setFormData(updatedForm)
    }
  }, [])

  useEffect(() => {
    const subscription = get("role/get_all_select").subscribe((response) => {
      setRoles(response.data.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [])

  const validations = {
    email: [
      SmartValid.required("Email Id is Required"),
      SmartValid.email("Please Enter a Valid Email Address"),
    ],
    password: [
      SmartValid.required("Password is Required"),
      SmartValid.minLength("Minimum 4 Digit", 4),
      SmartValid.maxLength("Maximum 15 Digit", 15),
    ],
  };

  const formElements:SmartFormInterFace.SmartFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: "7",
      name: "euserid",
      element: {
        classList: ["smart-form-input"],
        label: "Employee Id",
        placeHolder: "Enter your Employee Id",
        leftIcon: "fa-id-card",
        inputProps: {
          disabledFunction: () => {
            if (dataIn) return true
          }
        }
      },
    },
    {
      type: "SELECT_BOX",
      width: "5",
      name: "roles",
      element: {
        classList: ["smart-form-input"],
        label: "Role",
        placeHolder: "Select",
        isMulti: true,
        options: roles,
        validations: validations.email,
        inputProps: {
          disabledFunction: () => {
            if (dataIn) return true
          }
        }
      },
    },
    {
      type: "TEXT_BOX",
      width: "7",
      name: "ename",
      element: {
        classList: ["smart-form-input"],
        label: "Employee Name",
        placeHolder: "Enter your Name",
        inputType: "NORMAL",
        leftIcon: "fa-user",
      }
    },
    {
      type: "TEXT_BOX",
      width: "7",
      name: "emailid",
      element: {
        classList: ["smart-form-input"],
        label: "Email",
        leftIcon: "fa-at",
        validations: validations.email,
        placeHolder: "Enter your Email Id",
      },
    },
  ];

  const handleInputChange = (name: string, value: any) => {
    const val = (name == "role") || (name == "group") ? [value] : value
    setFormData((prev) => ({ ...prev, [name]: val }));
  };

  const getPayload = () => {
    if (dataIn) {
      return {
        id: dataIn?.ID,
        ename: formData?.ename,
        emailid: formData?.emailid,
      }
    } else return formData;
  }

  const handleSave = () => {
    if (formData?.ename == "") return showNotification("error", "Please insert the Employee name");
    setLoading(true)
    const payload = getPayload()
    const api = dataIn ? "user/update" : "user/insert"
    const subscription = post(api, payload).subscribe((response) => {
      setLoading(false)
      setFormData(initialValue);
      dataIn
        ? showNotification("success", "User Modified Successfully")
        : showNotification("success", "User Created Successfully")
      loadData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  return (
    <div className="sd-pdf-form">
      <SmartSoftForm
        formData={formData}
        setFormData={handleInputChange}
        elements={formElements}
      />
      <div className="has-text-right">
        <SmartSoftButton
          label={dataIn ? "Modify" : "Create"}
          classList={["smart-action-button"]}
          onClick={handleSave}
        />
      </div>
    </div>
  );
}

export default UsersForm;
